module.exports = __webpack_public_path__ + "img/Posada-cabo_0006_room2.af2b1bc7.jpg";